// extracted by mini-css-extract-plugin
export default {"Box_1":"VisibleItems-module__Box_1--LOtDr"};